import StatUtils from "./StatUtils";

export default class GoogleDataLayer extends StatUtils {
    constructor() {
        super();
        this.publishStatus = window.app_status === 'production';
        //this.publishStatus = window.app_status === 'local';

        //Remember pushed steps
        this.checkoutSteps = [];
    }

    pushFormOk(eventName) {
        if(this.publishStatus) {
            dataLayer.push({'event': eventName});
        } else {
            console.log('GA Form send event: ' + eventName);
        }
    }

    /**
     * Push products prom category list
     */
    pushCategoryList() {
        if(this.publishStatus) {
            let products = this.buildCategoryItems();
            if(products.length) {
                dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'UAH',
                        'impressions': products
                    },
                    'event': 'gtm-ee-event',
                    'gtm-ee-event-category': 'Enhanced Ecommerce',
                    'gtm-ee-event-action': 'Product Impressions',
                    'gtm-ee-event-non-interaction': 'True'
                });
            }
        } else {
            console.log('GA Category products event')
        }
    }

    /**
     * Push after open single product
     * @param productData
     */
    pushOpenSingleProduct(productData) {
        if(this.publishStatus) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'detail': {
                        'actionField': {'list': 'Повнотекст товару'},
                        'products': [{
                            'name': productData.name,
                            'id': productData.id,
                            'price': productData.price,
                            'brand': productData.brand,
                            'category': productData.category
                        }]
                    },
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Product Details',
                'gtm-ee-event-non-interaction': 'True',
            });
        } else {
            console.log(productData);
            console.log('GA Single product open event');
        }
    }

    /**
     * Push after add item to cart
     * @param productData
     */
    pushAddProductToCart(productData) {
        if(this.publishStatus) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'add': {
                        'products': [{
                            'name': productData.name,
                            'id': productData.id,
                            'price': productData.price,
                            'brand': productData.brand,
                            'category': productData.category,
                            'quantity': productData.quantity
                        }]
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
                'gtm-ee-event-non-interaction': 'False',
            });
        } else {
            console.log(productData);
            console.log('GA Add to cart event');
        }
    }

    /**
     * Push after remove product from cart
     * @param productData
     */
    pushRemoveProductFromCart(productData) {
        if(this.publishStatus) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'remove': {
                        'products': [{
                            'name': productData.name,
                            'id': productData.id,
                            'price': productData.price,
                            'category': productData.category,
                            'quantity': productData.quantity
                        }]
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Removing a Product from a Shopping Cart',
                'gtm-ee-event-non-interaction': 'False',
            });
        } else {
            console.log(productData);
            console.log('GA Remove from cart event');
        }
    }

    /**
     * Push all event from checkout page
     * @param stepData
     */
    pushCheckoutSteps(stepData) {
        let products = this.buildCheckoutItems();
        if(this.publishStatus) {
            if(!this.checkoutSteps.includes(stepData.step)) {
                dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'UAH',
                        'checkout': {
                            'actionField': stepData,
                            'products': products
                        }
                    },
                    'event': 'gtm-ee-event',
                    'gtm-ee-event-category': 'Enhanced Ecommerce',
                    'gtm-ee-event-action': 'Checkout Step ' + stepData.step,
                    'gtm-ee-event-non-interaction': 'False',
                });
                //Remember step
                this.checkoutSteps.push(stepData.step);
            }
        } else {
            console.log(stepData);
            console.log(products);
            console.log('GA Step event ' + stepData.step);
        }
    }

    /**
     * Push from thanx page
     * @param orderData
     */
    pushOrderData(orderData) {
        let products = this.buildCheckoutItems();
        if(this.publishStatus) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'UAH',
                    'purchase': {
                        'actionField': {
                            'id': orderData.id, // айди транзакции
                            'affiliation': 'BeSmart', //название магазина
                            'revenue': orderData.price, //общая стоимость покупки
                            'shipping': orderData.delivery_price, //Цена доставки
                            'coupon': orderData.coupon //название промокода если есть
                        },
                        'products': products
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Purchase',
                'gtm-ee-event-non-interaction': 'False',
            });
        } else {
            console.log(orderData);
            console.log(products);
            console.log('GA Thanx page');
        }
    }
}
